import { Badge } from "@fluentui/react-components";
import { ContractBranch } from "../../../../models/Entities/Contracts/ContractBranch";
import { Protocol } from "../../../../models/Entities/Protocols/Protocol";
import { ErrorType } from "../../../../models/HttpError";

// styles
import './BranchList.Styles.css';
import { ConfirmationButtonComponent } from "../../../../commons/component/ConfirmationButton/ConfirmationButtonComponent";
import { Building24Regular } from "@fluentui/react-icons";

////i18Next
import { useTranslation } from 'react-i18next';

export interface IProps {
    Branch: ContractBranch;
    index: number;
    onEdit?: (branch: ContractBranch) => void;
    onDelete?: (branch: ContractBranch) => void;
    deleteProcess: boolean;
    deleteSuccess: boolean | undefined;
    deleteError: boolean;
    Error: ErrorType | undefined;
    Protocols?: Protocol[];
}

export const BranchItemComponent = (props: IProps) => {
    //useTranslation()
    const [t] = useTranslation();

    const relatedProtocol = props.Protocols?.find(
        (protocol: Protocol) => protocol.id === props.Branch.protocolIdRelatedToBranch
    );

    return (
        <div className="bi-card">
            <button type="button" className="bi-main" onClick={() => props.onEdit && props.onEdit(props.Branch)}>
                <div className="bi-order">
                    <span className="bi-order-num">{props.index + 1}</span>
                    <span className="bi-order-label">{t('branchItem.textBranch')}</span>
                </div>

                <div className="bi-body">
                    <div className="bi-title-row">
                        <span className="bi-name" title={props.Branch.branchName}>{props.Branch.branchName}</span>
                    </div>

                    {props.Branch.branchDescription && (
                        <p className="bi-desc">{props.Branch.branchDescription}</p>
                    )}

                    {props.Branch.protocolIdRelatedToBranch && (
                        <div className="bi-meta-row">
                            <Badge appearance="tint" color="brand" size="small" className="bi-badge">
                                <Building24Regular />
                                <span className="bi-badge-label">
                                    {relatedProtocol?.title ?? t('branchItem.protocolFallback', 'Protocolo') + ` #${props.Branch.protocolIdRelatedToBranch}`}
                                </span>
                            </Badge>
                        </div>
                    )}
                </div>
            </button>

            <div className="bi-aside">
                <ConfirmationButtonComponent 
                    ButtonId={"deletebranch" + props.Branch.id} 
                    ButtonIconName={"Delete"} 
                    ButtonText={""} 
                    ButtonCssClass={""} 
                    ConfirmationButtonText={t('branchItem.confirmationButton.deleteButton')} 
                    ConfirmationButtonCssClass={"deleteButton"} 
                    CancelButtonText={t('branchItem.confirmationButton.cancelButton')} 
                    CancelButtonCssClass={""} 
                    Title={t('branchItem.confirmationButton.branchDeleteConfirm')} 
                    Description={""} 
                    ElementTextHeader={t('branchItem.confirmationButton.branchDelete') + props.Branch.branchName} 
                    ElementTextInformation={t('branchItem.confirmationButton.textInformation')} 
                    onConfirmation={() =>
                        props.onDelete && props.onDelete(props.Branch)
                    }
                    onCancel={() => undefined}
                    isOperationExecuting={props.deleteProcess}
                    isOperationExecutedWithError={props.deleteError}
                    OperationError={props.Error}
                />
                </div>
        </div>
    );
}